/* @refresh reload */
import { render } from "solid-js/web";
import { lazy } from "solid-js";
import { Route, Router } from "@solidjs/router";

import "./index.css";

const Account = lazy(() => import("./pages/account"));
const Home = lazy(() => import("./pages/home"));
const Help = lazy(() => import("./pages/help"));
const Join = lazy(() => import("./pages/join"));
const Login = lazy(() => import("./pages/login"));
const NotFound = lazy(() => import("./pages/not-found"));
const PasswordReset = lazy(() => import("./pages/password-reset"));
const PrivacyPolicy = lazy(() => import("./pages/privacy"));
const Signup = lazy(() => import("./pages/signup"));
const Splash = lazy(() => import("./pages/splash"));
const TermsOfService = lazy(() => import("./pages/tos"));
const VerifyEmail = lazy(() => import("./pages/verify-email"));
const VerifyPhone = lazy(() => import("./pages/verify-phone"));

const root = window.document.getElementById("root");
if (root) {
  render(
    () => (
      <Router>
        <Route path="/" component={Splash} />
        <Route path="/account" component={Account} />
        <Route path="/home" component={Home} />
        <Route path="/help" component={Help} />
        <Route path="/join" component={Join} />
        <Route path="/login" component={Login} />
        <Route path="/password-reset" component={PasswordReset} />
        <Route path="/verify-email" component={VerifyEmail} />
        <Route path="/verify-phone" component={VerifyPhone} />
        <Route path="/privacy" component={PrivacyPolicy} />
        <Route path="/signup" component={Signup} />
        <Route path="/tos" component={TermsOfService} />
        <Route path="*" component={NotFound} />
      </Router>
    ),
    root,
  );
}
